import React from 'react';

// Utils
import { useClass } from '@breezerr';

// Types
import type { MegaMenuDataModel } from '@brz-types/navigation.type';

// Components
import { Button, ButtonBase, Fade } from '@mui/material';
import { Uppercase } from '@brz-components/elements/uppercase';
import { newLinesToBreaks } from '@brz-utils/newlines.to.breaks';
import { Img } from '@brz-components/elements/img';
import { TextLink } from '@brz-components/elements/text.link';





type MegaMenuProps = {
    show: boolean;
    onClose(): void;
    data: MegaMenuDataModel;
};

export const MegaMenu = (props: MegaMenuProps) => {
    const { data } = props;

    const [active, setActive] = React.useState(0);

    return (
        <Fade in={props.show} appear timeout={250}>
            <div 
                className={useClass('p-absolute w-100% bg-color-white')}
            >
                <div 
                    className={useClass('container d-grid grid-cols-12 gap-x-2x p-relative min-h-100% pt-2rem pb-4rem')}
                >

                    <div className={useClass('col-span-4 mt-1.2rem')}>
                        <Uppercase className={useClass('mb-3.8rem')}>{data.heading}</Uppercase>
                        <div className={`thin-scrollbar ${useClass('of-y-auto pl-2rem -ml-4rem')}`} style={{
                            maxHeight: 'calc(100vh - 20rem)'
                        }}>
                            {data.items.map((item, index) => {
                                return (
                                    <ButtonBase
                                        key={index}
                                        className={useClass(`py-2rem pl-2rem pr-3rem d-flex justify-content-start align-items-start text-left w-33rem radius-2rem mb-2rem hover:bg-color-grey:50 bg-color-${active === index ? 'accent:50!' : 'white'}`)}
                                        onClick={() => setActive(index)}
                                    >
                                        <div className={useClass(`w-3.6rem h-3.6rem mr-2rem bg-color-${active === index ? 'accent:100' : 'grey'} radius-1rem`)}>
                                            <Img src={item.icon} width={36} height={36} alt={`${item.title} Icon`} loading="lazy" />
                                        </div>
                                        <div className={useClass('d-flex flex-column align-items-start max-w-22rem')}>
                                            <span className={useClass('d-block text-size-1.4rem lh-2rem text-800 mb-1rem')} dangerouslySetInnerHTML={{ __html: newLinesToBreaks(item.title) }}></span>
                                            <span
                                                className={useClass(`d-block text-size-1.3rem lh-1.8rem text-400 text-color-${active === index ? 'accent:1000' : 'primary'}`)}
                                                dangerouslySetInnerHTML={{ __html: newLinesToBreaks(item.description) }}
                                            ></span>
                                        </div>
                                    </ButtonBase>
                                );
                            })}
                        </div>
                    </div>

                    <div className={useClass('col-span-8')}>
                        {data.items.map((item, index) => (
                            <div key={index} className={useClass(`${active === index ? 'd-block' : 'd-none'}`)}>
                                {/* Breadcrumb */}
                                <div className={useClass('d-inline-flex align-items-center px-1.5rem py-0.7rem text-size-1.2rem text-600 bg-color-grey:50 radius-1.5rem mb-2.8rem')}>
                                    <span className={useClass('cursor-default')}>{data.title}</span>
                                    <svg className={useClass('mx-1rem')} xmlns="http://www.w3.org/2000/svg" width="5.838" height="8.847" viewBox="0 0 5.838 8.847">
                                        <path d="M0,0,3.01,3.01,6.019,0" transform="translate(1.414 7.433) rotate(-90)" fill="none" stroke="#54687a" strokeLinecap="round" strokeWidth="2" />
                                    </svg>
                                    {item.buttons?.[0]?.link ? (
                                        <TextLink className={useClass('no-underline!')} href={item.buttons?.[0]?.link}>{item.title}</TextLink>
                                    ) : (
                                        <span>{item.title}</span>
                                    )}
                                </div>
                                
                                {/* Banner */}
                                <div className={useClass('d-flex px-4.5rem py-3rem bg-color-grey:50 radius-2rem p-relative')}>
                                    <div className={useClass('')}>
                                        <h4 className={useClass('mb-2rem')} dangerouslySetInnerHTML={{ __html: newLinesToBreaks(item.title) }}></h4>
                                        {item.buttons.map((button, index) => (
                                            <Button
                                                key={index}
                                                href={button.link}
                                            >{button.label}</Button>
                                        ))}
                                    </div>

                                    {item.image?.src ? (
                                        <Img 
                                            className={useClass('d-block p-absolute right-5rem xl:right-10rem bottom-0x max-h-27rem w-auto')}
                                            {...item.image}
                                        />
                                    ) : null} 
                                </div>

                                {/* Links */}
                                <div className={`thin-scrollbar ${useClass('d-flex justify-content-between border-box pl-5rem pr-8rem xl:pr-14rem pt-3rem of-y-auto')}`} style={{
                                    maxHeight: 'calc(100vh - 40rem)'
                                }}>{
                                    item.columns.map((column, index) => (
                                        <nav key={index} className={useClass('')}>
                                            <div className={useClass('text-size-1.4rem text-600 mb-2rem')}>{ column.title }</div>
                                            <ul className={`clean ${useClass('my-0x')}`}>{
                                                column.links.map((item, index) => (
                                                    <li className={useClass('mt-0rem mb-0.75rem')} key={index}>
                                                        
                                                        <TextLink className={useClass('no-underline! text-size-1.4rem')} href={item.link}>{ item.label }</TextLink>
                                                    </li>
                                                ))
                                            }</ul>
                                        </nav>
                                    ))
                                }</div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </Fade>
    )
};